export default __webpack_public_path__ + "static/media/payment.0d15bd8c.svg";